// extracted by mini-css-extract-plugin
export default {"wrapperModalChangePass":"CustomModalClose_wrapperModalChangePass__iufWc","container":"CustomModalClose_container__v7sFP"};